import { Component, OnInit } from '@angular/core';
import { AuthorizationService } from '../../authorization/authorization.service';
import { LoadingService } from '../../../util/loader.service';
import { environment } from './../../../../environments/environment';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss']
})
export class InicioComponent implements OnInit {
  userName = '';
  testador = false;
  environmentName = '';

  constructor(private authService: AuthorizationService, public loader: LoadingService) { }

  ngOnInit() {
    if (environment.name !== 'production') {
      this.environmentName = environment.name;
    }

    this.carregaNome();
  }

  carregaNome() {
    let result = this.authService.GetLocalAuthorizationData();
    this.userName = result.Nome;
  }
}
